export const MAX_CONDITION_GROUP_DEPTH = 3
